<template>
  <v-container>
    <v-card>
      <v-overlay :value="loader" :absolute="true">
        <v-row justify="center">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-row>
      </v-overlay>
      <v-card-title>
        <v-row justify="center">
          <h1 class="text-xs-center primary--text">{{ $t("setupUpdate") }}</h1>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h1 class="text-xs-center primary--text">
              {{ $t("changelog") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-col class="pt-0">
              <div v-for="changelog in changelogs" :key="changelog.version">
                <p class="black--text">
                  <b>Version:</b> {{ changelog.version }}
                  <br />
                  <b>Beschreibung:</b> {{ changelog.description }}
                </p>
              </div>
            </v-col>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="4">
            <v-card outlined>
              <v-card-title>
                <h1 class="text-xs-center primary--text">{{ $t("tables") }}</h1>
              </v-card-title>
              <v-card-text>
                <v-row v-for="item in tables" :key="item.text">
                  <v-col class="pa-1">
                    <v-progress-linear :value="item.finishedInPercent" height="25" color="green" reactive>
                      <strong>{{ item.text }}</strong>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-col>
                  <v-row justify="end">
                    <v-btn
                      color="primary"
                      @click="createTables"
                      :disabled="tables.length == 0 || disableTablesButton"
                      class="textColor--text font-weight-medium buttonHoverOpacity"
                      >{{ $t("execute") }}</v-btn
                    >
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card outlined>
              <v-overlay :value="loaderOverlayFields" :absolute="true"></v-overlay>
              <v-card-title>
                <h1 class="text-xs-center primary--text">
                  {{ $t("tableFields") }}
                </h1>
              </v-card-title>
              <v-card-text>
                <v-row v-for="item in fields" :key="item.text">
                  <v-col class="pa-1">
                    <v-progress-linear :value="item.table.finishedInPercent" height="25" color="green" reactive>
                      <strong>{{ item.table.TableName }}({{ item.fields.length }})</strong>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-col>
                  <v-row justify="end">
                    <v-btn
                      color="primary"
                      :disabled="fields.length == 0 || disableFieldsButton"
                      @click="createFields"
                      class="textColor--text font-weight-medium buttonHoverOpacity"
                      >{{ $t("execute") }}</v-btn
                    >
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card outlined>
              <v-overlay :value="loaderOverlayDatas" :absolute="true"></v-overlay>
              <v-card-title>
                <h1 class="text-xs-center primary--text">
                  {{ $t("tableData") }}
                </h1>
              </v-card-title>
              <v-card-text>
                <v-row v-for="item in data" :key="item.tableName">
                  <v-col class="pa-1">
                    <v-progress-linear :value="item.finishedInPercent" height="25" color="green" reactive>
                      <strong>{{ item.tableName }}({{ item.dataValues.length }})</strong>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-col>
                  <v-row justify="end">
                    <v-btn
                      color="primary"
                      @click="createData"
                      :disabled="data.length == 0 || disableDataButton"
                      class="textColor--text font-weight-medium buttonHoverOpacity"
                      >{{ $t("execute") }}</v-btn
                    >
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Setup",
  route: "Setup",
  data: () => ({
    initialSetup: false,
    loader: false,
    loaderOverlayFields: true,
    loaderOverlayDatas: true,
    disableTablesButton: false,
    disableFieldsButton: false,
    disableDataButton: false,
    tables: [],
    fields: [],
    data: [],
    changelogs: []
  }),
  created: function () {
    this.getUpdateInfos();
  },
  methods: {
    getUpdateInfos: function () {
      this.$store
        .dispatch("server/setup/getUpdateInfos")
        .then((resp) => {
          if (!resp.data.success) {
            // Internal Server Error
          }
          console.log(resp);
          if (typeof resp.data.data === "string") {
            if (resp.data.data == "notInSetup") {
              this.$eventHub.$emit("showError", this.$t("notInSetupMode"));
              this.$store.dispatch("user/logout").then(() => {
                this.$router.push("/Login");
              });
              return;
            }
          }
          this.tables = resp.data.data.tables;
          this.fields = resp.data.data.fieldData;
          this.data = resp.data.data.data;
          this.changelogs = resp.data.data.changelogs;

          if (this.tables.length == 0) {
            this.loaderOverlayFields = false;
          }

          if (this.tables.length == 0 && this.fields.length == 0) {
            this.loaderOverlayDatas = false;
          }

          if (this.tables.length == 0 && this.fields.length == 0 && this.data.length == 0) {
            this.$dialog
              .confirm(this.$t("installSuccessfullPleaseRefresh"))
              .then(() => {})
              .catch(() => {});
          }

          console.log(this.tables);
        })
        .catch((err) => {
          console.log(err);
          this.$eventHub.$emit("showError", this.$t("serviceNotReachablePleaseRefresh"));
        });
    },
    createTables: async function () {
      this.disableTablesButton = true;
      let sendTables = this.tables.filter((table) => table.finished == false);
      let allImported = true;
      for (let i = 0; i < sendTables.length; i++) {
        await this.$store.dispatch("server/setup/createTable", sendTables[i]).then((resp) => {
          if (!resp.data.success) {
            // Internal Server Error
            allImported = false;
            alert("Error " + resp.data.error);
          } else {
            sendTables[i].finishedInPercent = 100;
            sendTables[i].finished = true;
          }
        });
      }
      if (allImported) {
        this.$dialog
          .confirm(this.$t("pleaseRestartServiceLayer"))
          .then(() => {
            this.restartServer();
          })
          .catch(() => {
            this.restartServer();
          });
      }
      // if (allImported) this.loaderOverlayFields = false;
    },
    createFields: async function () {
      this.disableFieldsButton = true;
      let sendFields = this.fields.filter((field) => field.table.finished == false);
      let importedEveryField = true;
      let allImported = true;
      for (let i = 0; i < sendFields.length; i++) {
        for (let d = 0; d < sendFields[i].fields.length; d++) {
          await this.$store
            .dispatch("server/setup/createField", {
              fieldName: sendFields[i].fields[d].Name,
              tableName: sendFields[i].table.TableName
            })
            .then((resp) => {
              if (!resp.data.success) {
                // Internal Server Error
                allImported = false;
                importedEveryField = false;
                alert("Error " + resp.data.error);
              } else {
                sendFields[i].table.finishedInPercent = ((d + 1) / sendFields[i].fields.length) * 100;
              }
            });
        }
        if (importedEveryField) {
          sendFields[i].table.finishedInPercent = 100;
          sendFields[i].table.finished = true;
        }
      }
      if (allImported) {
        this.$dialog
          .confirm(this.$t("pleaseRestartServiceLayer"))
          .then(() => {
            this.restartServer();
          })
          .catch(() => {
            this.restartServer();
          });
      }
    },
    createData: async function () {
      this.disableDataButton = true;
      let sendData = this.data.filter((data) => data.finished == false);
      let allImported = true;
      for (let i = 0; i < sendData.length; i++) {
        let importedEveryData = true;
        for (let d = 0; d < sendData[i].dataValues.length; d++) {
          await this.$store
            .dispatch("server/setup/createData", {
              tableName: sendData[i].tableName,
              keyField: sendData[i].keyField,
              data: sendData[i].dataValues[d]
            })
            .then((resp) => {
              if (!resp.data.success) {
                // Internal Server Error
                allImported = false;
                importedEveryData = false;
                alert("Error " + resp.data.error);
              } else {
                sendData[i].finishedInPercent = ((d + 1) / sendData[i].dataValues) * 100;
              }
            });
        }
        if (importedEveryData) {
          sendData[i].finishedInPercent = 100;
          sendData[i].finished = true;
        }
      }
      if (allImported) {
        this.$dialog
          .confirm(this.$t("installSuccessfull"))
          .then(() => {
            this.restartServer(true);
          })
          .catch(() => {
            this.restartServer(true);
          });
      }
    },
    restartServer: async function (isFinished = false) {
      this.loader = true;
      await this.$store
        .dispatch("server/setup/restartServer")
        .then((resp) => {
          console.log(resp);
          if (resp.data.success) {
            this.loader = false;
            let message = "";
            if (isFinished) message = this.$t("installSuccessfull");
            else message = this.$t("serviceLayerRestartedSuccessfully");
            this.$dialog
              .confirm(message)
              .then(() => {
                location.reload();
              })
              .catch(() => {
                location.reload();
              });
          }
        })
        .catch((err) => {
          this.$eventHub.$emit("showError", this.$t("serviceNotReachablePleaseRefresh"));
        });
    }
  }
};
</script>
